import { useActivitiesContext } from '../../../context'
import { useSelector } from 'react-redux'
import { selectAllSalesTeamUsers } from '@user/store/salesTeam'
import { ActivityForm } from '../typings'
import { useFormikContext } from 'formik'

export function useData() {
  const [{ activityTypes }] = useActivitiesContext()
  const owners = useSelector(selectAllSalesTeamUsers)

  const { errors } = useFormikContext<ActivityForm>()
  const dueDateValid = !errors.dueDate

  return {
    activityTypes,
    dueDateValid,
    owners,
  }
}
